// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1-qeV","tab":"ProcedureTabs_tab__umKWi"};